<template>
    <span aria-hidden="true" class="spacer" :class="[spacerClass, classes.spacer]"></span>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Classes {
    spacer?: string;
}

interface Props {
    spacerSize?: 'small' | 'medium' | 'large';
    classes?: Classes;
}

const props = withDefaults(defineProps<Props>(), {
    spacerSize: 'medium',
    classes: () => ({
        spacer: '',
    }),
});

// if spacerSize is small height is 10px, if medium 20px, if large 30px
const spacerClass = computed(() => {
    if (props.spacerSize === 'small') {
        return 'spacer--small';
    } else if (props.spacerSize === 'medium') {
        return 'spacer--medium';
    } else if (props.spacerSize === 'large') {
        return 'spacer--large';
    }
    return 'spacer--small'; // default to medium
});
</script>